"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _Spinner = _interopRequireDefault(require("./Spinner"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "spin": "DefaultTheme__spin___2BLHD",
  "spinner": "DefaultTheme__spinner___1ZqfV",
  "s": "DefaultTheme__s___1Ezcf",
  "m": "DefaultTheme__m___FFO2l",
  "l": "DefaultTheme__l___3u_d-"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "spinner": "DarkTheme__spinner___3yNHB",
  "s": "DarkTheme__s___1X_Gq",
  "m": "DarkTheme__m___1T7UJ",
  "l": "DarkTheme__l___3zdVO"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "spinner": "LumeTheme__spinner___1zWlc"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  LumeTheme: LumeTheme,
  DarkTheme: DarkTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_Spinner["default"].displayName, themes.DefaultTheme)(_Spinner["default"]);
ThemedComponent.displayName = _Spinner["default"].displayName;
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map